import { PaginatedResponse, Tag } from '@/api/interfaces';
import axios, { AxiosPromise } from 'axios';

import { Query } from '../query';

const resources = {
  default: 'core/tags',
};

type tagCreateData = {
  name: string;
  slug: string | null;
  description: string;
  color: string;
};

interface TagApiInterface {
  getTags: (
    model?: string,
  ) => AxiosPromise<PaginatedResponse<Tag>>;
  create: (data: tagCreateData) => AxiosPromise<Tag>;
  update: (
    slug: string,
    data: tagCreateData,
  ) => AxiosPromise<Tag>;
  delete: (slug: string) => AxiosPromise<void>;
}

const tagApi: TagApiInterface = {
  getTags(model) {
    const query = new Query({});
    if (model) {
      query.addParam('model', model);
    }
    return axios.get(`${resources.default}/${query}`);
  },
  create(data: tagCreateData) {
    return axios.post(`${resources.default}/`, data);
  },
  update(slug, data: tagCreateData) {
    return axios.patch(`${resources.default}/${slug}/`, data);
  },
  delete(slug) {
    return axios.delete(`${resources.default}/${slug}/`);
  },
};

export default tagApi;

export { TagApiInterface, tagCreateData };

